import React, { useState } from 'react'
import CustomInput from '../../custominput/CustomInput'

function AdditionalPage({handleSubmit}) {
  const [formData, setFormData] = useState({
    business_email: '',
    business_contact_number: '',
    business_industry: '2',  // Default value for "Select Business Industry"
    business_size: '2',       // Default value for "Business Size"
    primary_products_services: '2',  // Default value for "Primary Products or Services"
    number_of_stores: ''
  })

  const [errors, ] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }))
  }

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", marginTop: '40px' }}>
        <p
          className="card-title mb-3"
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "left",
            color: "#000",
            width: '100%',
          }}
        >
          Additional Information
        </p>
      </div>

      <div className="mb-3">
        <CustomInput
          type="email"
          id="businessEmail"
          name="business_email"
          placeholder="Business Email Address"
          value={formData.business_email}
          onChange={handleChange}
          required
          error={Boolean(errors.business_email)}
          helpertext={errors.business_email || ""}
        />
      </div>

      <div className="mb-3">
        <CustomInput
          type="tel"
          id="businessContact"
          name="business_contact_number"
          placeholder="Business Contact Number"
          value={formData.business_contact_number}
          onChange={handleChange}
          required
          error={Boolean(errors.business_contact_number)}
          helpertext={errors.business_contact_number || ""}
        />
      </div>

        {/* Business Industry (Select Dropdown with Default Value 2) */}
        <div className="mb-3">
        <CustomInput
          isSelect={true}
          id="businessIndustry"
          name="business_industry"
          placeholder="Business Industry"
          value={formData.business_industry}
          onChange={handleChange}
          style={{color:"#828282" , fontSize:'17px'}}
          options={[
            { value: '1', label: 'Industry 1' },
            { value: '2', label: 'Industry 2' },
            { value: '3', label: 'Industry 3' },
            { value: '4', label: 'Industry 4' }
          ]}
          required
          error={Boolean(errors.business_industry)}
          msg={errors.business_industry || ''}
        />
      </div>

      {/* Business Size (Select Dropdown with Default Value 2) */}
      <div className="mb-3">
        <CustomInput
          isSelect={true}
          id="businessSize"
          name="business_size"
          placeholder="Business Size"
          value={formData.business_size}
          onChange={handleChange}
          style={{color:"#828282" , fontSize:'17px'}}
          options={[
            { value: '', label: 'Select Business Size' },  // Default placeholder option
            { value: '1', label: 'Size 1' },
            { value: '2', label: 'Size 2' },
            { value: '3', label: 'Size 3' },
            { value: '4', label: 'Size 4' }
          ]}
          required
          error={Boolean(errors.business_size)}
          msg={errors.business_size || ''}
        />
      </div>

      {/* Primary Products or Services (Select Dropdown with Default Value 2) */}
      <div className="mb-3">
        <CustomInput
          isSelect={true}
          id="primaryProductsServices"
          name="primary_products_services"
          placeholder="Primary Products or Services"
          value={formData.primary_products_services}
          onChange={handleChange}
          style={{color:"#828282" , fontSize:'17px'}}
          options={[
            { value: '1', label: 'Products or Services 1' },
            { value: '2', label: 'Products or Services 2' },
            { value: '3', label: 'Products or Services 3' },
            { value: '4', label: 'Products or Services 4' }
          ]}
          required
          error={Boolean(errors.primary_products_services)}
          msg={errors.primary_products_services || ''}
        />
      </div>

      <div className="mb-3">
        
        <CustomInput
          type="number"
          id="numberOfStores"
          name="number_of_stores"
          placeholder="Number of Stores"
          value={formData.number_of_stores}
          onChange={handleChange}
          required
          error={Boolean(errors.number_of_stores)}
          helpertext={errors.number_of_stores || ""}
          style={{ width: '100%' }}
        />
      </div>

      {/* Create Account Button */}
      <div style={{ marginTop: '20px' }}>
        <button
          type="button"
          onClick={handleSubmit}
          style={{
            backgroundColor: '#0D532F',
            color: 'white',
            padding: '20px 20px',
            fontSize: '16px',
            border: 'none',
            borderRadius: '40px',
            cursor: 'pointer',
            maxWidth:'198px',
            height:'60px',
            width: '100%',
            marginLeft:'32%',
            display:"flex",
            justifyContent:'center',
            textAlign:'center',
            justifyItems:'center'
          }}
        >
      Create User
        </button>
      </div>
    </>
  )
}

export default AdditionalPage
